export function useSessionId() {
  const params = new URLSearchParams(window.location.search)
  const sessionId = params.get('sessionId')

  return sessionId
}
